/** This export is automatically generated */
export const gitHash = 'd9f6dc366';
